import Bacon from 'baconjs';
import _ from 'underscore';

import {Dispatcher} from './infrastructure/dispatcher';

const {push, stream} = new Dispatcher();

export function dismissNotification(id) {
    push('delete', id);
}

let cid = 0;
export function pushNotification(notification) {
    const id = cid++;
    push('add', {...notification, id});

    // Setup automated dismissal of successful notifications
    if (notification.type === 'success') {
        _.delay(dismissNotification, 15000, id);
    }

    return id;
}

export function updateNotification(previousId, notification) {
    dismissNotification(previousId);

    return pushNotification(notification);
}

export default Bacon.update(
    [],
    [stream('add')],
    (notifications, newNotification) =>
        notifications.concat(newNotification).sort((a, b) => b.id - a.id),
    [stream('delete')],
    (notifications, deletedId) =>
        notifications.filter((notification) => notification.id !== deletedId)
);
